module.exports = {
    login: 'login',
    loginByAccount: 'account login',
    inputAccount: 'Enter account',
    inputPassword: 'Enter password',
    verificationCode:'verification code',
    forgotPassword:'forgot password',
    experience:'Registration free experience',
    loginTitle1:'easy operation ',
    loginTitle2:'Process details',
    loginTitle3:'Financial accuracy',
    loginTitle4:'Intuitive data display',
    lastTime:'Last login time',
    waitTodo:'Wait to be done',
    remember:'Remember the password',
    //按钮
    search:'search',
    reset:'reset',
    add:'add',
    save:'save',
    templateDownload:'Template download',
    importGoods:'Import goods',
    addGoods:'Add goods',
    edit:'edit',
    delete:'delete',
    copy:'copy',
    examine:'examine',
    revocation:'revocation',
    confirm:'confirm',
    inStorage:'in storage',
    outStorage:'out storage',
    print:'Print',
    exportDocument:'Export Document',
    saveDraft:'Save Draft',
    close:'Close',
    reject:'Reject',
    createNewProduct:'Create New Product',
    approved:'Approved',
    historicalSalesPrice:'Historical Sales Price',
    historicalPurchasePrice:'Historical Purchase Price',
    export:'Export',
    generateInboundOrder:'Generate Inbound Order',
    cancle:'Cancel',
    confirmInbound:'Confirm Inbound',
    confirmOutbound:'Confirm Outbound',
    EorD:'Enable/Disable',
    batchImport:'Batch Import',
    batchEdit:'Batch Edit',
    enable:'Enable',
    disable:'Disable',
    inquiryRecords:'Inquiry Records',
    barcode:'Barcode',
    //表格
    No:'No.',
    documentNumber:'Document number',
    warehouse:'warehouse',
    supplier:'supplier',
    supplierInformation: 'supplierInformation',
    client:'client',
    commodityAmount:'Commodity amount',
    otherAmount:'otherAmount',
    totalAmount:'Total amount',
    status:'status',
    createTime:'Creation time',
    completionTime:'Completion time',
    startTime:'start time',
    endTime:'end time',
    operator:'operator',
    approver:'approver',
    deliveryTime: 'delivery time',
    remark:'remark',
    operate:'operate',
    goodsName:'goods name',
    goodsId:'goods id',
    brand:'brand',
    category:'category',
    select:'select',
    amountPayable:'Amount payable',
    amountReceivable:'Amount receivable',
    paymentMethod:'Payment method',
    quantity:'quantity',
    unitPrice:'Unit price',
    amount:'amount',
    storageLocation:'storage location',
    unit:'unit',
    internalCode:'Internal code',
    specification:'specification',
    approvalComments:'Approval Comments',
    details:'Details',
    inventoryQuantity:'Inventory Quantity',
    historicalPrice:'Historical Price',
    amountPaid:'Amount Paid',
    creator:'Creator',
    phoneNum:'Mobile Number',
    customerInformation:'Customer Information',
    basicInformation:'Basic Information',
    contactPerson:'Contact Person',
    image:'Image',
    retailPrice:'Retail Price',
    wholesalePrice:'Wholesale Price',
    otherPrice:'Other Prices',
    foreignName:'Foreign Name',
    itemLength:'long(mm)',
    itemWide:'wide(mm)',
    itemHigh:'high(mm)',
    itemWeight:'net weight(Kg)',
    defectiveQuantity:'Defective Quantity',
    otherOccupation:'Other Occupation',
    availableQuantity:'Available Quantity',
    changeTime:'Change Time',
    landline:'Landline',
    fax:'Fax',
    address:'Address',
    bankOfAccount:'Bank of Account',
    bankAccountNumber:'Bank Account Number',
    taxNum:'Tax Number',
    //提示
    operationSuccessful:'Operation Successful',
    pleaseAddProduct:'Please Add Product',
    unitNotBeNull:'Quantity and Unit Price Cannot Be Empty',
    quantityNotBeDecimal:'Quantity Cannot Be a Decimal',
    unitPriceNotBeNegative:'Unit Price Cannot Be Negative',
}